#import "../../../../../core/select/fragments/market-fragment.graphql"

fragment MarketForLeadFragment on Lead {
    id
    market {
        ...MarketFragment
    }
}
